import styled from 'styled-components';

import {
  Button,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

export const Search = styled(Flex).attrs({
  align: 'center',
})`
  width: 100%;
  margin-bottom: 10px;

  & > div {
    width: 100%;
  }
`;

export const LearnMore = styled(Button).attrs({
  ghost: true,
  appearance: 'primary',
})`
  svg g {
    stroke: ${props => props.theme.colors.primary};
  }

  &:hover {
    color: #fff;
    background: ${props => props.theme.colors.primary};

    svg g {
      stroke: #fff;
    }
  }
`;
